// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type DiscoveryEvent = {
  featureKey: string;
  action: "impression" | "cta";
  plane?: "org" | "plan" | null | undefined;
  reason?: "locked" | "quota" | null | undefined;
  metric?: string | null | undefined;
};
export const DiscoveryEventSchema = z.object({
  featureKey: z.string().min(3).max(60),
  action: z.enum(["impression", "cta"] as const),
  plane: z.enum(["org", "plan"] as const).nullable().optional(),
  reason: z.enum(["locked", "quota"] as const).nullable().optional(),
  metric: z.string().min(1).max(60).nullable().optional(),
}).strict();

export type RecordDiscoveryResponse = {
  ok: boolean;
};

export async function recordDiscovery(body: DiscoveryEvent): Promise<RecordDiscoveryResponse> {
  const response = await api.post<RecordDiscoveryResponse>(`/discovery/events`, body);
  return response.data;
}

export const discoveryKeys = {
  all: ["discovery"] as const,
  lists: () => [...discoveryKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...discoveryKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...discoveryKeys.all, 'detail'] as const,
  detail: (id: string) => [...discoveryKeys.details(), id] as const,
};
